import React from 'react';
import Center from "../Center";
import style from './style.module.css';

const Section = ({ id = "", className = "", children, center = true }) => {
    return (
        <div id={id} className={`${style.section}${className ? " " + className : ""}`}>
            {
                center === true && (
                    <Center>{children}</Center>
                )
            }
            {
                center === false && (
                    <>{children}</>
                )
            }
        </div>
    )
}

export default Section;